module.exports = __webpack_public_path__ + "img/iconos-categorias-03.eff55d7d.svg";